module.exports = __webpack_public_path__ + "static/media/takeaway_footer.2f7c2acb.svg";